import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRecycle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.6665 4V10M21.6665 10H15.6665M21.6665 10L18.1665 6.5C16.7097 5.04318 14.7381 4.18801 12.6665 4.18801C8.4644 4.18801 5.05602 7.54618 4.87302 11.7208M3.6665 20V14M3.6665 14H9.6665M3.6665 14L7.1665 17.5C8.62332 18.9568 10.5949 19.812 12.6665 19.812C16.8686 19.812 20.277 16.4538 20.46 12.2792",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRecycle;
